"use client";

import Image from "next/image";
import Link from "next/link";
import Container from "@/app/components/ui/container";
import { Button } from "@/app/components/ui/button";

export default function NotFound() {
  return (
    <Container>
      <div className="flex min-h-[90svh] flex-col items-center justify-center text-center">
        <Image
          src="/404-error.webp"
          alt="404 - Seite nicht gefunden"
          width={300}
          height={300}
          className="mb-8"
          priority
        />
        <h1 className="text-foreground mb-4 text-3xl font-bold">
          Seite nicht gefunden
        </h1>
        <p className="text-muted-foreground mb-8 max-w-md">
          Die gesuchte Seite existiert nicht oder wurde verschoben. Bitte kehren
          Sie zur Startseite zurück.
        </p>
        <Button asChild>
          <Link href="/">Zur Startseite</Link>
        </Button>
      </div>
    </Container>
  );
}
